import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/Axelerate_logo.svg'
import _imports_1 from '../../assets/Ilustration.png'


const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center rounded bg-background" }
const _hoisted_2 = { class: "flex flex-col bg-white lg:shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-lg w-full max-w-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pt-5 pb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "login logo",
    class: "w-5/12 lg:pb-5"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "illustration",
    class: "w-5/12 lg:pb-5"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold self-start text-xl sm:text-2xl text-gray" }, " Confirm your email address ", -1)
const _hoisted_5 = { class: "mt-8 mb-8 text-black text-sm overflow-clip tracking-normal text-justify" }
const _hoisted_6 = { class: "flex justify-center items-center mt-6 text-sm" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Can’t find the email?", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3 inline-flex items-center text-primary font-bold text-sm text-centerml-2" }, "We can resend it", -1)
const _hoisted_9 = { class: "flex justify-center items-center mt-6 text-sm" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Made a mistake?", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3 inline-flex items-center text-primary font-bold text-sm text-centerml-2" }, "Start again", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3 inline-flex items-center text-sm text-centerml-2" }, " or ", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Login ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, _toDisplayString(`Almost done! An email from Axelerate has been sent to
        ${_ctx.route.query.email}. Please follow the instructions in the email to
        finish setting up your account.`), 1),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_router_link, { to: "/log-in" }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode(_component_router_link, { to: "/sign-up" }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }),
      _hoisted_12,
      _createVNode(_component_router_link, {
        class: "ml-3 inline-flex items-center text-primary font-bold text-sm text-centerml-2",
        to: "/log-in"
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ])
  ]))
}